import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import ThunderstormIcon from "@mui/icons-material/Thunderstorm";

const items = [
  {
    icon: <QuestionMarkIcon />,
    title: "Who we are ?",
    description:
      "A precision-tuned software engineering studio, guiding companies through complexity to deliver swift, tangible, real-world outcomes for digital products, solutions, and services.",
  },
  {
    icon: <PsychologyAltIcon />,
    title: "Why choose us ?",
    description:
      "We're on a mission to revolutionize access to affordable, preventative software solutions for everyone, utilizing robust and scalable technology.",
  },
  {
    icon: <GroupsIcon />,
    title: "Our team",
    description:
      "Choose us for our exceptional team of software developers, quality assurance engineers, designers, and scrum masters dedicated to creating an equitable digitized software system.",
  },
  {
    icon: <ThunderstormIcon />,
    title: "We strive for perfection",
    description:
      "Whether Fortune 500 or startup, we craft disruptive web and mobile apps tailored to your customer's needs, driven by cutting-edge user experience.",
  },
];

export default function AboutUs() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: "white",
        bgcolor: "#419F6E",
      }}
    >
      <Container
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: "100%", md: "60%" },
            textAlign: { sm: "left", md: "center" },
          }}
        >
          <Typography component="h2" variant="h4">
            About Us
          </Typography>
          <Typography variant="body1" sx={{ color: "grey.200", fontSize: 20 }}>
            Your gateway to a world of software engineering excellence.
          </Typography>
        </Box>
        <Grid container spacing={2.5}>
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Stack
                direction="column"
                color="inherit"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  p: 3,
                  height: "100%",
                  border: "1px solid",
                  borderColor: "grey.800",
                  background: "transparent",
                  backgroundColor: "#216F46",
                }}
              >
                <Box sx={{ opacity: "50%" }}>{item.icon}</Box>
                <div>
                  <Typography fontWeight="bold" fontSize={20} gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "grey.200", fontSize: 16 }}
                  >
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
